import { useEffect, useState } from 'react'
import { styled, Button, Stack, SvgIcon, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stepper, StepLabel, Step, CircularProgress } from '@mui/material';
import { ReactComponent as CrossIcon } from '../../icons/cross.svg';
import { ulid } from 'ulidx';

// import CreateRouteDialogFlights from './CreateRouteDialogFlights';
// import CreateRouteDialogSummary from './CreateRouteDialogSummary';
import { toast } from 'react-toastify';
import CreateDelayCommEventProperties from './CreateDelayCommEventProperties';
import { Message } from '@aviation/cabinapp-message-service-sdk';
import CreateDelayCommEventFlights from './CreateDelayCommEventFlights';
import CreateDelayCommEventAttributes from './CreateDelayCommEventAttributes';
import { put } from 'aws-amplify/api';

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

export interface ICreateDelayCommStep {
    id: number;
    key: string;
    label: string;
    valid: boolean;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <SvgIcon component={CrossIcon} inheritViewBox />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export interface ICreateEventDialogProps {
    cancelAction: () => void;
    createAction: (item : Message) => void;
}

export function CreateDelayCommEventDialog(props: ICreateEventDialogProps) {
    const [ isUpdatingMessage, setisUpdatingMessage] = useState(false);
    const [ isLoading] = useState(false);
    const [ currentMessage, setCurrentMessage] = useState<Message>({});

    const initialSteps : ICreateDelayCommStep[] = [
        { id: 0, key: 'properties', label: 'Category', valid: false},
        { id: 1, key: 'flights', label: 'Flight', valid: false},
        { id: 2, key: 'finish', label: 'Finish', valid: false}
    ];

    const [stepList, setStepList] = useState(initialSteps);
    const [activeStep, setActiveStep] = useState<ICreateDelayCommStep>(stepList[0]);

    const handleClose = () => {
        props.cancelAction();
    }

    const handleCreate = async () => {
        setisUpdatingMessage(true);

        var payload = currentMessage;
        if(payload.Id === undefined)
            payload.Id = ulid().toString();

        try {
            await put({ path: `/api/message/`, apiName: 'api', options: { body: payload as any}});
            toast.success(`Delay communication created successfully.`);
            props.createAction(payload);
        } catch(e) {
            console.error(e);
            toast.error(`An error occurred while creating delay communication.`);
            return false;
        } finally {
            setisUpdatingMessage(false);
            setCurrentMessage({});
        }
    }

    useEffect(() => {
        // set default values
        var item = {...currentMessage};
        item.Id = ulid().toString();
    }, [currentMessage]);

    const validationExecuted = (item : Message, valid : boolean) => {
        const newState = { ...activeStep, valid: valid };
        setActiveStep(newState);
        let list = stepList;
        list[activeStep.id] = newState;
        setStepList(list);
        setCurrentMessage(item);
    }

    const nextStep = () => {
        if(activeStep.key === 'finish') {
            handleCreate();
        } else {
            setActiveStep(stepList[activeStep.id + 1]);
        }
    }

    const previousStep = () => {
        if(activeStep.id === 0)
            return;

        setActiveStep(stepList[activeStep.id - 1]);
    }

    return (
        <div>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={true}
                maxWidth='lg'
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    <Stack>
                        <p style={{paddingTop:0, marginTop:0}}>Create Delay Communication</p>
                        <Stack direction='row' useFlexGap flexWrap="wrap" spacing={1}>
                            <Stepper activeStep={activeStep.id}>
                            {
                                stepList.map(s => (
                                    <Step key={s.key}><StepLabel>{s.label}</StepLabel></Step>
                                ))
                            }
                            </Stepper>
                        </Stack>

                    </Stack>
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    { isLoading && <div style={{display: 'flex', justifyContent: 'center', padding:40}}><CircularProgress size={25}/></div> }
                    { !isLoading && activeStep.key === 'properties' && <CreateDelayCommEventProperties item={currentMessage} validationExecuted={validationExecuted} />}
                    { !isLoading && activeStep.key === 'flights' && <CreateDelayCommEventFlights  item={currentMessage} validationExecuted={validationExecuted} />}
                    { !isLoading && activeStep.key === 'finish' && <CreateDelayCommEventAttributes item={currentMessage} validationExecuted={validationExecuted} />}
                </DialogContent>
                <DialogActions>
                    { !isUpdatingMessage && <Button autoFocus onClick={handleClose}>
                        Cancel
                    </Button> }
                    { !isUpdatingMessage && activeStep.id > 0 && <Button autoFocus onClick={previousStep}>
                        Back
                    </Button> }
                    
                    { !isUpdatingMessage && <Button autoFocus onClick={nextStep} disabled={!activeStep.valid}>
                        { activeStep.key !== 'finish' ? 'Next' : 'Create' }
                    </Button> }
                    { isUpdatingMessage && (<CircularProgress size={25} />)}
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}

export default CreateDelayCommEventDialog;